import { useState, useCallback, Fragment } from "react";
import { Button, Modal, message } from "antd";
import { ToTopOutlined } from "@ant-design/icons";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function MessagePublishButton({ messageId, callback, title, sendee }) {
  const [visible, setVisible] = useState(false);
  const auth = useAuthContext();
  const clickHandler = useCallback(() => {
    setVisible(true);
  }, [setVisible]);
  const okHandler = useCallback(() => {
    messageService.publishMessage(messageId, auth.token).then(() => {
      setVisible(false);
      message.success("操作成功");
      callback(Date.now());
    });
  }, [messageId, callback, auth]);
  const cancelHandler = useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  return (
    <Fragment>
      <Button size="small" icon={<ToTopOutlined />} onClick={clickHandler} />

      <Modal
        title="确认上报"
        visible={visible}
        onOk={okHandler}
        onCancel={cancelHandler}
        okText="确认"
        cancelText="取消"
      >
        <p>接收单位：{sendee}</p>
        <p>信息标题：{title}</p>
      </Modal>
    </Fragment>
  );
}

export default MessagePublishButton;
